module.exports = __webpack_public_path__ + "img/hidegeofence.33b71889.png";